import { typo } from '@cycle-app/ui';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 1px 16px 16px 40px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  overflow: hidden;
`;

export const Title = styled.div`
  ${typo.body500}
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
`;
